import { isAndroidWebView, generateUID } from './handlers/share';
import { sendMessageToAndroid } from './sender';
import { EWebViewEvents, IWebViewEvent } from './types';

export const sendMetaAndShareMeeting = (url: string): boolean => {
  const uid = generateUID();
  const metaMsg: IWebViewEvent = { type: EWebViewEvents.SHARE_META, payload: { meta: true, id: uid } };
  const shareMsg: IWebViewEvent = { type: EWebViewEvents.SHARE_TEXT, payload: { url, id: uid } };
  if (isAndroidWebView()) {
    sendMessageToAndroid(metaMsg);
    sendMessageToAndroid(shareMsg);
    return true;
  }
  return false;
};

export const sendEventToWebView = ({
  eventType,
  payload = {},
}: {
  eventType: EWebViewEvents;
  payload?: Partial<IWebViewEvent['payload']>;
}) => {
  if (isAndroidWebView()) {
    const uid = generateUID();
    const message: IWebViewEvent = {
      type: eventType,
      payload: { id: uid, ...payload },
    };
    sendMessageToAndroid(message);
  }
  return;
};
